export default "__VITE_ASSET__BHqh51wr__"